<template>
  <v-row>
    <v-row class="card card-front">

      <section class="section-image mt-8">
        <v-img
          :src="require('@/assets/img/user.png')"
          class="img-photo"
          fixed>
        </v-img>
      </section>

      <section class="section-title pl-2 pr-2">
        <h3 style="font-weight: 500;" class="text-uppercase">{{ data.name +' '+ data.lastname }}</h3>
      </section>

      <template v-if="data.status==0">
        <h2 class="section-not-perfil pl-2 pr-2">
          Perfil en construcción.
        </h2>
      </template>

      <template v-if="data.status==1">
        <section class="section-studies pl-2 pr-2" v-if="data.completed_studie_id==1">
          <p
            style="font-weight: 600;" 
            class="text-uppercase">
            {{ data.secundary_tertiary_career }}
          </p>
        </section>

        <section class="section-studies pl-2 pr-2" v-if="data.completed_studie_id==1">
          <p 
            style="font-weight: 400;" 
            class="pt-1">
            {{ data.secundary_tertiary_institute }}
          </p>
        </section>

        <section class="section-studies pl-2 pr-2" v-if="data.completed_studie_id==1">
          <p 
            style="font-weight: 300;" 
            class="pt-1">
            Estudiante de escuela secundaria
          </p>
        </section>

        <!-------------------------------------->

        <section class="section-studies pl-2 pr-2" v-if="data.completed_studie_id==2">
          <h3
            style="font-weight: 600;" 
            class="text-uppercase">
            {{ data.secundary_tertiary_career }}
          </h3>
        </section>

        <section class="section-studies pl-2 pr-2" v-if="data.completed_studie_id==2">
          <h4 
            style="font-weight: 400;" 
            class="pt-1">
            {{ data.secundary_tertiary_institute }}
          </h4>
        </section>

        <section class="section-studies pl-2 pr-2" v-if="data.completed_studie_id==2">
          <h4 
            style="font-weight: 300;" 
            class="pt-1">
            Estudiante/graduado
          </h4>
        </section>

        <!-------------------------------------->

        <section class="section-studies pl-2 pr-2" v-if="data.university=='unl'&&data.completed_studie_id==3">
          <h3
            style="font-weight: 600;" 
            class="text-uppercase">
            {{ (data.career)?data.career.name:'--' }}
          </h3>
        </section>

        <section class="section-studies pl-2 pr-2" v-if="data.university=='unl'&&data.completed_studie_id==3">
          <h4
            style="font-weight: 400;" 
            class="pt-1">
            Universidad Nacional del Litoral
          </h4>
        </section>

        <section class="section-studies pl-2 pr-2" v-if="data.university=='unl'&&data.completed_studie_id==3">
          <h4
            style="font-weight: 300;" 
            class="pt-1">
            Estudiante
          </h4>
        </section>

        <!-------------------------------------->

        <section class="section-studies pl-2 pr-2" v-if="data.university!='unl'&&data.completed_studie_id==3">
          <h3
            style="font-weight: 600;" 
            class="text-uppercase">
            {{ data.other_career }}
          </h3>
        </section>

        <section class="section-studies pl-2 pr-2" v-if="data.university!='unl'&&data.completed_studie_id==3">
          <h4 
            style="font-weight: 400;" 
            class="pt-1">
            {{ data.other_university }}
          </h4>
        </section>

        <section class="section-studies pl-2 pr-2" v-if="data.university!='unl'&&data.completed_studie_id==3">
          <h4 
            style="font-weight: 300;" 
            class="pt-1">
            Estudiante
          </h4>
        </section>

        <!-------------------------------------->
        
        <section class="section-studies pl-2 pr-2" v-if="data.university=='unl'&&data.completed_studie_id==4">
          <h3
            style="font-weight: 600;" 
            class="text-uppercase">
            {{ data.career.name }}
          </h3>
        </section>

        <section class="section-studies pl-2 pr-2" v-if="data.university=='unl'&&data.completed_studie_id==4">
          <h4
            style="font-weight: 400;" 
            class="pt-1">
            Universidad Nacional del Litoral
          </h4>
        </section>

        <section class="section-studies pl-2 pr-2" v-if="data.university=='unl'&&data.completed_studie_id==4">
          <h4
            style="font-weight: 300;" 
            class="pt-1">
            Graduado
          </h4>
        </section>

        <!-------------------------------------->

        <section class="section-studies pl-2 pr-2" v-if="data.university!='unl'&&data.completed_studie_id==4">
          <h3
            style="font-weight: 600;" 
            class="text-uppercase">
            {{ data.other_career }}
          </h3>
        </section>

        <section class="section-studies pl-2 pr-2" v-if="data.university!='unl'&&data.completed_studie_id==4">
          <h4 
            style="font-weight: 400;" 
            class="pt-1">
            {{ data.other_university }}
          </h4>
        </section>

        <section class="section-studies pl-2 pr-2" v-if="data.university!='unl'&&data.completed_studie_id==4">
          <h4 
            style="font-weight: 300;" 
            class="pt-1">
            Graduado
          </h4>
        </section>
      </template>

      <section class="section-social">

        <div @click="handleIconClick(data.id)" style="cursor: pointer;">
          <v-icon>mdi-send-outline</v-icon>
        </div>

        <a v-if="data.linkedin" :href="data.linkedin" target="_blank">
          <v-icon>
            mdi-linkedin
          </v-icon>
        </a>

        <a v-if="data.facebook" :href="data.facebook" target="_blank">
          <v-icon>
            mdi-facebook
          </v-icon>
        </a>

        <a v-if="data.instagram" :href="data.instagram" target="_blank">
          <v-icon>
            mdi-instagram
          </v-icon>
        </a>

        <a v-if="data.twitter" :href="data.twitter" target="_blank">
          <v-icon>
            mdi-twitter
          </v-icon>
        </a>

        <a v-if="data.youtube" :href="data.youtube" target="_blank">
          <v-icon>
            mdi-youtube
          </v-icon>
        </a>

        <a v-if="data.twitch" :href="data.twitch" target="_blank">
          <v-icon>
            mdi-twitch
          </v-icon>
        </a>

        <a v-if="data.tiktok" :href="data.tiktok" target="_blank">
          <v-icon>
            mdi-tiktok
          </v-icon>
        </a>

        <a v-if="data.snapchat" :href="data.snapchat" target="_blank">
          <v-icon>
            mdi-snapchat
          </v-icon>
        </a>

        <a v-if="data.discord" :href="data.discord" target="_blank">
          <v-icon>
            mdi-discord
          </v-icon>
        </a>

        <a v-if="data.telegram" :href="data.telegram" target="_blank">
          <v-icon>
            mdi-telegram
          </v-icon>
        </a>

        <a v-if="data.email" :href="'mailto:'+data.email" target="_blank">
          <v-icon>
            mdi-email
          </v-icon>
        </a>
      </section>
      
      <v-divider class="mt-4"></v-divider>
    </v-row>

    <v-dialog
      v-model="dialog_message"
      persistent
      max-width="380"
    >
      <v-card>
        <v-card-title class="text-h5">
          Mensaje privado
        </v-card-title>
        <v-card-text>
          {{ data.name+ ' ' + data.lastname }}
          
            <v-textarea
              outlined
              class="pt-4"
              name="input-7-4"
              label="Mensaje"
              v-model="message"
            ></v-textarea>

        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary darken-1"
            text
            @click="dialog_message = false"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!message"
            color="primary darken-1"
            text
            @click="sendMessage()"
            :loading="loading_send"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'

  export default {
    name: 'cardEntrepreneur',
    props:['data'],

    data: () => ({
      dialog_message: false,
      loading_send:false,
      message:'',
      receiver_id: null,
      error: false,
    }),
    methods:{
      handleIconClick(id){
        this.receiver_id = id
        this.message = ''
        this.dialog_message = true
      },

      async sendMessage()
      {
        try {
          this.loading_send = true
          await axios.post('messages',{
            message: this.message, 
            receiver_id: this.receiver_id, 
            }).then(response =>{
              this.message = ''
              this.dialog_message = false
              this.loading_send = false
              console.log(response)
            })
          } catch (error) {
              this.message = ''
              this.dialog_message = false
              this.loading_send = false
              console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
          }
      },

    },
  }
</script>

<style type='text/css' scoped>
ul {
  padding-left: 0;
  display: flex;
  flex-flow: row wrap;
}

li {
  list-style-type: none;
  padding: 10px 10px;
  transition: all 0.3s ease;
}
.container {
  max-width: 100%;
  padding: 2em;
}
.card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 380px;
  background-color: #ffffff;
  border-radius: 4px;
  line-height: 27px;
  position: relative;
  will-change: transform;
}
.card-front {
  display: block;
  text-align: center;
  font-weight: 300;
  font-size: 18px;
}
.img-photo {
  max-height: 90px;
  max-width: 90px;
  min-height: 90px;
  min-width: 90px;
  border-radius: 50%; 
}
.img-flag{
  height: auto;
  max-width: 36px;
}

.section-image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
}

.section-title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}
.section-studies {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
}
.section-not-perfil {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 126px;
}
.section-social {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}
</style>